import { render, staticRenderFns } from "./water-fall.vue?vue&type=template&id=1ae928be&scoped=true&"
import script from "./water-fall.vue?vue&type=script&lang=js&"
export * from "./water-fall.vue?vue&type=script&lang=js&"
import style0 from "./water-fall.vue?vue&type=style&index=0&id=1ae928be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae928be",
  null
  
)

export default component.exports